import React, { useEffect, useState } from "react"
import moment from "moment"
import "moment/locale/ja"
import Constants from "../../common/components/constants.jsx"
import ajax from "../../common/components/ajax.jsx"
import "../../sass/topics.scss"
import { isFullScreenCategory } from "./Utils"
import TextField from "@mui/material/TextField/TextField.js"
import { Button } from "@mui/material"
import Dialog from "@mui/material/Dialog/Dialog.js"
import DialogContent from "@mui/material/DialogContent/DialogContent.js"
import { DialogTitle } from "@mui/material"
import { DialogActions } from "@mui/material"
import { FormControl } from "@mui/material"
import { InputLabel } from "@mui/material"
import { MenuItem } from "@mui/material"
import { Input } from "@mui/material"
import { RadioGroup } from "@mui/material"
import { FormControlLabel } from "@mui/material"
import { Radio } from "@mui/material"
import { Select } from "@mui/material"
import { TextareaAutosize } from "@mui/material"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import YouTubeIcon from "@mui/icons-material/YouTube"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import ImageIcon from "@mui/icons-material/Image"
import Stack from "@mui/material/Stack"
import { DialogContentText } from "@mui/material"

function TopicForm(props) {
  const [categories, setCategorys] = useState(props.categories)

  const [editAuthorized, setEditAuthorized] = useState("")
  const [patrolAuthorized, setPatrolAuthorized] = useState("")

  const [alertItems, setAlertItems] = useState({
    alertTitle: "",
    alertBody: "",
    alertModalIsOpen: false,
  })

  const [isOpen, setIsOpen] = useState(props.isOpen)

  const [headerText, setHeaderText] = useState(
    props.isNew ? "新規トピックの追加" : "トピックの編集"
  )
  const [submitText, setSubmitText] = useState(props.isNew ? "追加" : "保存")

  const [topicItems, setTopicItems] = useState({
    TOPIC_ID: props.TOPIC_ID,
    CATEGORY_ID: props.CATEGORY_ID,
    TOPIC_TITLE: props.TOPIC_TITLE,
    TOPIC_BODY: props.TOPIC_BODY,
    TOPIC_AUTHOR_NAME: props.TOPIC_AUTHOR_NAME,
    TOPIC_AVAILABLE_FROM: props.TOPIC_AVAILABLE_FROM,
    TOPIC_AVAILABLE_TO: props.TOPIC_AVAILABLE_TO,
    MEDIAS: props.MEDIAS,
    PATROLLED: props.PATROLLED,
    TOPIC_CREATED: props.TOPIC_CREATED,
  })

  const [youtubeUrl, setYoutubeUrl] = useState("")
  const [youtubeModalIsOpen, setYoutubeModalIsOpen] = useState(false)

  const [pdfModalIsOpen, setPdfMOdalIsOpen] = useState(false)
  const [pdfType, setPdfType] = useState("")

  const [is_full_screen_category, set_is_full_screen_category] = useState(
    props.CATEGORY_ID &&
      isFullScreenCategory(props.categories, props.CATEGORY_ID)
  )

  useEffect(() => {
    const authKey =
      typeof props.TOPIC_ID !== "undefined" && !!props.TOPIC_ID
        ? "EDIT_TOPIC"
        : "CREATE_TOPIC"
    const newEditAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty(authKey) &&
      props.auth.role[authKey]
    const newPatrolAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty("PATROL_TOPIC") &&
      props.auth.role.PATROL_TOPIC

    setCategorys(props.categories)

    setEditAuthorized(newEditAuthorized)
    setPatrolAuthorized(newPatrolAuthorized)

    setIsOpen(props.isOpen)

    setHeaderText(props.isNew ? "新規トピックの追加" : "トピックの編集")
    setSubmitText(props.isNew ? "追加" : "保存")

    setTopicItems({
      TOPIC_ID: props.TOPIC_ID,
      CATEGORY_ID: props.CATEGORY_ID,
      TOPIC_TITLE: props.TOPIC_TITLE,
      TOPIC_BODY: props.TOPIC_BODY,
      TOPIC_AUTHOR_NAME: props.TOPIC_AUTHOR_NAME,
      TOPIC_AVAILABLE_FROM: props.TOPIC_AVAILABLE_FROM,
      TOPIC_AVAILABLE_TO: props.TOPIC_AVAILABLE_TO,
      MEDIAS: props.MEDIAS,
      PATROLLED: props.PATROLLED,
      TOPIC_CREATED: props.TOPIC_CREATED,
    })

    set_is_full_screen_category(
      props.CATEGORY_ID &&
        isFullScreenCategory(props.categories, props.CATEGORY_ID)
    )
  }, [props])

  const onChangeTitle = (val) => {
    if (!editAuthorized) return
    props.onChangeTitle(val)
  }

  const onChangeAuthor = (val) => {
    if (!editAuthorized) return
    props.onChangeAuthor(val)
  }

  const onChangeBody = (val) => {
    if (!editAuthorized) return
    props.onChangeBody(val)
  }

  const onChangeFrom = (val) => {
    if (!editAuthorized) return
    props.onChangeFrom(val)
  }

  const onChangeTo = (val) => {
    if (!editAuthorized) return
    props.onChangeTo(val)
  }

  const onChangeCategory = (val) => {
    if (!editAuthorized) return
    props.onChangeCategory(parseInt(val, 10))
  }

  const onChangePatrolled = (val) => {
    if (!editAuthorized && !patrolAuthorized) return
    props.onChangePatrolled(val)
  }

  const onSubmit = (form) => {
    if (!editAuthorized && !patrolAuthorized) return
    props.onSubmit(form)
  }

  const onMediaTitleChange = (val, index) => {
    if (!editAuthorized) return

    let medias = topicItems.MEDIAS.map((media, i) => {
      if (i !== index) return media
      media.TITLE = val
      return media
    })
    props.onChangeMedias(medias)
  }

  const onMediaCommentChange = (val, index) => {
    if (!editAuthorized) return

    let medias = topicItems.MEDIAS.map((media, i) => {
      if (i !== index) return media
      media.COMMENT = val
      return media
    })
    props.onChangeMedias(medias)
  }

  const onMediaSizeChange = (val, index) => {
    if (!editAuthorized) return

    let medias = topicItems.MEDIAS.map((media, i) => {
      if (i !== index) return media
      media.DISPLAY_SIZE = val
      return media
    })
    props.onChangeMedias(medias)
  }

  const onMediaRemove = (index) => {
    if (!editAuthorized) return

    let medias = []
    if (topicItems.MEDIAS[index].TYPE !== "video") {
      medias = topicItems.MEDIAS.filter((media, i) => {
        return i !== index
      })
    }
    props.onChangeMedias(medias)
  }

  const onAddImageButtonClicked = () => {
    if (!editAuthorized) return

    if (topicItems.MEDIAS.length > 0 && topicItems.MEDIAS[0].TYPE === "video") {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "画像と動画を同時に添付することはできません。画像を添付するには、動画の添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    document.getElementById("fileForm").click()
  }

  const onAddPdfButtonClicked = () => {
    if (!editAuthorized) return

    if (topicItems.MEDIAS.length > 0 && topicItems.MEDIAS[0].TYPE === "video") {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "画像と動画を同時に添付することはできません。画像を添付するには、動画の添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    if (topicItems.MEDIAS.length > 0 && topicItems.MEDIAS[0].TYPE === "image") {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "画像とPDFを同時に添付することはできません。PDFを添付するには、画像の添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    document.getElementById("fileFormPdf").click()
  }

  const onAddImage = (files) => {
    if (!editAuthorized) return

    let medias = topicItems.MEDIAS

    // fileの数だけfalseを入れた配列を作る
    let counter = []

    let index = 0
    for (const file of files) {
      const reader = new FileReader()
      reader.onloadend = (e) => {
        if (!e.target.error) {
          counter[e.target.index] = {
            TITLE: file.name,
            TYPE: "image",
            BASE64: e.target.result,
            COMMENT: "",
            DISPLAY_SIZE: "LARGE",
          }
        }

        console.log("counter", counter)
        const notyet =
          counter.filter((val) => {
            return typeof val === "boolean"
          }).length > 0
        if (!notyet) {
          counter.forEach((val) => {
            if (typeof val !== "boolean") {
              medias.push(val)
            }
          })
          props.onChangeMedias(medias)
        }
      }
      reader.index = index
      reader.readAsDataURL(file)

      counter.push(false)
      index++
    }
  }

  const onAddPdf = (files) => {
    if (!editAuthorized) return

    let medias = []

    // fileの数だけfalseを入れた配列を作る
    let counter = []

    let index = 0
    for (const file of files) {
      const reader = new FileReader()
      reader.onloadend = (e) => {
        if (!e.target.error) {
          counter[e.target.index] = {
            TITLE: file.name,
            TYPE: pdfType,
            BASE64: e.target.result,
            COMMENT: "",
            DISPLAY_SIZE: "LARGE",
          }
        }
        const notyet =
          counter.filter((val) => {
            return typeof val === "boolean"
          }).length > 0
        if (!notyet) {
          counter.forEach((val) => {
            if (typeof val !== "boolean") {
              medias.push(val)
            }
          })
          props.onChangeMedias(medias)
        }
      }
      reader.index = index
      reader.readAsDataURL(file)

      counter.push(false)
      index++
    }
    togglePdfModal()
  }

  const toggleYoutubeModal = () => {
    if (!editAuthorized) return

    if (topicItems.MEDIAS.length > 0) {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "動画を添付する場合、他に画像や動画を同時に添付することはできません。他のメディアの添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    setYoutubeModalIsOpen(!youtubeModalIsOpen)
  }

  const onDecideYouTubeURL = () => {
    const YOUTUBE_API_KEY =
      process.env.NODE_ENV === "production"
        ? " AIzaSyDKQ6DRcxh5VM6Rg4vns_93eIEUJd_A-VA"
        : "AIzaSyAW7FrHNJgjq91mgUGhEppGNiSyMuDagu8"
    const YOUTUBE_VIDEO_ID = parse_youtube_url(youtubeUrl)
    if (!YOUTUBE_VIDEO_ID) {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody: "動画が見つかりませんでした",
        alertModalIsOpen: true,
      })
      return
    }
    const YOUTUBE_API_URL = `https://www.googleapis.com/youtube/v3/videos?key=${YOUTUBE_API_KEY}&part=snippet&id=${YOUTUBE_VIDEO_ID}`

    ajax.get(
      YOUTUBE_API_URL,
      (successJson) => {
        if (
          typeof successJson.items === "undefined" ||
          successJson.items.length === 0
        ) {
          setAlertItems({
            alertTitle: "メディア添付エラー",
            alertBody: "動画が見つかりませんでした",
            alertModalIsOpen: true,
          })
          return
        }

        const snippet = successJson.items[0].snippet

        toggleYoutubeModal()
        props.onChangeMedias([
          {
            TITLE: snippet.title || "",
            TYPE: "video",
            BASE64: snippet.thumbnails.medium.url,
            URL: `https://www.youtube.com/watch?v=${YOUTUBE_VIDEO_ID}`,
            COMMENT: snippet.description || "",
            DISPLAY_SIZE: "LARGE",
          },
        ])
      },
      (errorJson) => {
        console.log(errorJson)
      },
      true
    )
  }

  const parse_youtube_url = (youtubeUrl) => {
    try {
      const url = new URL(youtubeUrl)
      switch (url.hostname) {
        case "www.youtube.com":
          var queries = url.search.substring(1).split("&")
          for (var i = 0; i < queries.length; i++) {
            var keyval = queries[i].split("=")
            if (keyval[0] === "v") return keyval[1] || ""
          }
          break
        case "www.youtube-nocookie.com":
        case "youtu.be":
          var dirs = url.pathname.split("/")
          return dirs[dirs.length - 1]
        default:
          return ""
      }
      return ""
    } catch (e) {
      return ""
    }
  }

  const togglePdfModal = () => {
    if (!editAuthorized) return

    if (topicItems.MEDIAS.length > 0 && topicItems.MEDIAS[0].TYPE === "video") {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "画像と動画を同時に添付することはできません。画像を添付するには、動画の添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    if (topicItems.MEDIAS.length > 0 && topicItems.MEDIAS[0].TYPE === "image") {
      setAlertItems({
        alertTitle: "メディア添付エラー",
        alertBody:
          "画像とPDFを同時に添付することはできません。PDFを添付するには、画像の添付を解除してください。",
        alertModalIsOpen: true,
      })
      return
    }
    setPdfMOdalIsOpen(!pdfModalIsOpen)
  }
  const closeAlertModal = () => {
    setAlertItems((prevTopic) => ({ ...prevTopic, alertModalIsOpen: false }))
  }

  // 画像サイズ選択セレクトボックス
  const mediaDisplaySizeOptions = [
    { value: "LARGE", label: "大" },
    { value: "MEDIUM", label: "中" },
    { value: "SMALL", label: "小" },
  ]

  console.log("rerend", is_full_screen_category)

  // カテゴリ選択セレクトボックス
  let categorySelectFormOptions = []
  if (typeof categories !== "undefined" && categories.length > 0) {
    // FormSelect は数値を受け付けないので文字列にする
    categorySelectFormOptions = categories.map((category) => {
      return {
        label: category.CATEGORY_NAME,
        value: "" + category.CATEGORY_ID,
      }
    })
  }

  let editImage
  if (typeof topicItems.MEDIAS !== "undefined") {
    if (topicItems.MEDIAS.length) {
      if (
        topicItems.MEDIAS[0].TYPE === "pdf_normal" ||
        topicItems.MEDIAS[0].TYPE === "pdf_spread"
      ) {
        editImage = (
          <ul className="thumbnails">
            {topicItems.MEDIAS.map((media, index) => {
              return (
                <li key={index}>
                  <div className="info">
                    <TextField
                      disabled={!editAuthorized}
                      placeholder="タイトル"
                      value={media.TITLE?.replace(/\\n/g, "\n")}
                      onChange={(evt) => {
                        onMediaTitleChange(evt.currentTarget.value, index)
                      }}
                    />
                    <TextField
                      disabled={!editAuthorized}
                      multiline
                      placeholder="コメント"
                      value={media.COMMENT?.replace(/\\n/g, "\n")}
                      onChange={(evt) => {
                        onMediaCommentChange(evt.currentTarget.value, index)
                      }}
                    />
                    <div className="bottom">
                      {/* shareTilesでは画像のサイズは自動で変更される */}
                      {/* <FormControl variant="standard">
                                                <RadioGroup
                                                    row
                                                    disabled={true}
                                                    label="表示サイズ"
                                                    value={media.DISPLAY_SIZE ? media.DISPLAY_SIZE : "LARGE"}
                                                    onChange={(e) => {
                                                        onMediaSizeChange(e.target.value, index);
                                                    }}
                                                >
                                                    {mediaDisplaySizeOptions.map((option) => (
                                                        <FormControlLabel
                                                         key={option.value}
                                                         value={option.value}
                                                         control={<Radio color="primary"/>}
                                                         label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup >
                                            </FormControl>  */}
                      <div className="buttons">
                        <Button
                          variant="outlined"
                          disabled={!editAuthorized}
                          onClick={(evt) => {
                            onMediaRemove(index)
                          }}
                        >
                          削除
                        </Button>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else if (
        topicItems.MEDIAS.length === 2 &&
        (topicItems.MEDIAS[0].TYPE === "video" ||
          topicItems.MEDIAS[1].TYPE === "video")
      ) {
        //ビデオの場合
        const videosIndex = topicItems.MEDIAS[0].TYPE === "video" ? 0 : 1
        const url = topicItems.MEDIAS[videosIndex ? 0 : 1].URL?.replace(
          "getimage-origin",
          "getimage(dh=150,dw=150,pt=ptss)"
        )
        const media = topicItems.MEDIAS[videosIndex]
        editImage = (
          <ul className="thumbnails">
            <li>
              <div
                className="drawer"
                style={{ backgroundImage: `url('${url}')` }}
              ></div>
              <div className="info">
                <TextField
                  disabled={!editAuthorized}
                  placeholder="タイトル"
                  value={media.TITLE?.replace(/\\n/g, "\n")}
                  onChange={(evt) => {
                    onMediaTitleChange(evt.currentTarget.value, videosIndex)
                  }}
                />
                <TextField
                  disabled={!editAuthorized}
                  multiline
                  placeholder="コメント"
                  value={media.COMMENT?.replace(/\\n/g, "\n")}
                  onChange={(evt) => {
                    onMediaCommentChange(evt.currentTarget.value, videosIndex)
                  }}
                />
                <div className="bottom">
                  {/* shareTilesでは画像のサイズは自動で変更される */}
                  {/* <FormControl variant="standard" disabled={!editAuthorized || media.TYPE === 'video'}>
                                        <RadioGroup
                                            row
                                            disabled={true}
                                            label="表示サイズ"
                                            value={media.DISPLAY_SIZE ? media.DISPLAY_SIZE : "LARGE"}
                                            onChange={(e) => {
                                                onMediaSizeChange(e.target.value, index);
                                            }}
                                        >
                                            {mediaDisplaySizeOptions.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio color="primary"/>}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup >
                                    </FormControl>  */}
                  <div className="buttons">
                    <cite>
                      URL:{" "}
                      <a href={media.URL} target="_blank">
                        {media.URL}
                      </a>
                    </cite>

                    <Button
                      variant="outlined"
                      disabled={!editAuthorized}
                      onClick={(evt) => {
                        onMediaRemove(videosIndex)
                      }}
                    >
                      削除
                    </Button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        )
      } else {
        editImage = (
          <ul className="thumbnails">
            {topicItems.MEDIAS.map((media, index) => {
              let url = ""
              if (media.hasOwnProperty("URL")) {
                url = media.URL?.replace(
                  "getimage-origin",
                  "getimage(dh=150,dw=150,pt=ptss)"
                )
              }
              if (media.hasOwnProperty("BASE64")) {
                url = media.BASE64
              }

              return (
                <li key={index}>
                  <div
                    className="drawer"
                    style={{ backgroundImage: `url('${url}')` }}
                  ></div>
                  <div className="info">
                    <TextField
                      disabled={!editAuthorized}
                      placeholder="タイトル"
                      value={media.TITLE?.replace(/\\n/g, "\n")}
                      onChange={(evt) => {
                        onMediaTitleChange(evt.currentTarget.value, index)
                      }}
                    />
                    <TextField
                      disabled={!editAuthorized}
                      multiline
                      placeholder="コメント"
                      value={media.COMMENT?.replace(/\\n/g, "\n")}
                      onChange={(evt) => {
                        onMediaCommentChange(evt.currentTarget.value, index)
                      }}
                    />
                    <div className="bottom">
                      {/* shareTilesでは画像のサイズは自動で変更される */}
                      {/* <FormControl variant="standard">
                                                <RadioGroup
                                                    row
                                                    disabled={true}
                                                    label="表示サイズ"
                                                    value={media.DISPLAY_SIZE ? media.DISPLAY_SIZE : "LARGE"}
                                                    onChange={(e) => {
                                                        onMediaSizeChange(e.target.value, index);
                                                    }}
                                                >
                                                    {mediaDisplaySizeOptions.map((option) => (
                                                        <FormControlLabel
                                                         key={option.value}
                                                         value={option.value}
                                                         control={<Radio color="primary"/>}
                                                         label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup >
                                            </FormControl>  */}
                      <div className="buttons">
                        <Button
                          type="link-text"
                          className="download"
                          onClick={(evt) => {
                            const a = document.createElement("a")
                            let filename = media.TITLE
                            if (!/\.jpe?g/i.test(filename)) {
                              filename += ".jpg"
                            }

                            a.href = media.URL.replace("-origin", "()")
                            a.download = filename
                            a.click()
                          }}
                        >
                          ダウンロード
                        </Button>

                        <Button
                          type="link-cancel"
                          disabled={!editAuthorized}
                          onClick={(evt) => {
                            onMediaRemove(index)
                          }}
                        >
                          削除
                        </Button>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      }
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        props.toggleModal()
      }}
      aria-labelledby="form-dialog-title"
      fullScreen={true}
    >
      <DialogTitle>{headerText}</DialogTitle>
      <DialogContent>
        <div className="datepicker_wrapper">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <FormControl fullWidth={true} component="fieldset">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <DateTimePicker
                  variant="standard"
                  sx={{ width: "100%", border: "none" }}
                  label="配信期日 開始日"
                  onChange={(val) => {
                    onChangeFrom(val)
                  }}
                  defaultValue={topicItems.TOPIC_AVAILABLE_FROM}
                  maxDate={topicItems.TOPIC_AVAILABLE_TO}
                />
                <div style={{ width: "20px", height: "auto" }} />
                <DateTimePicker
                  variant="standard"
                  sx={{ width: "100%" }}
                  label="配信期日 終了日"
                  onChange={(val) => {
                    onChangeTo(val)
                  }}
                  defaultValue={topicItems.TOPIC_AVAILABLE_TO}
                  minDate={topicItems.TOPIC_AVAILABLE_FROM}
                />
              </div>
            </FormControl>
          </LocalizationProvider>
        </div>

        <FormControl
          fullWidth
          variant="standard"
          component="fieldset"
          disabled={!editAuthorized}
          sx={{ mb: "20px" }}
        >
          <InputLabel>カテゴリ</InputLabel>
          <Select
            label="カテゴリ"
            variant="standard"
            value={"" + topicItems.CATEGORY_ID}
            onChange={(e) => onChangeCategory(e.target.value)}
          >
            {categorySelectFormOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {!is_full_screen_category && (
          <FormControl
            fullWidth
            variant="standard"
            component="fieldset"
            sx={{ mb: "20px" }}
          >
            <InputLabel shrink>タイトル（100字以内）</InputLabel>
            <div style={{ height: "20px" }} />
            <TextField
              required
              variant="standard"
              disabled={!editAuthorized}
              placeholder="タイトルを入力してください"
              defaultValue={topicItems.TOPIC_TITLE || null}
              onChange={(e) => onChangeTitle(e.target.value)}
            />
          </FormControl>
        )}

        <FormControl
          fullWidth
          variant="standard"
          component="fieldset"
          sx={{ mb: "20px" }}
        >
          <InputLabel shrink>作者名</InputLabel>
          <div style={{ height: "20px" }} />
          <TextField
            required
            variant="standard"
            disabled={!editAuthorized}
            placeholder="作成者名を入力してください"
            defaultValue={topicItems.TOPIC_AUTHOR_NAME || null}
            onChange={(e) => onChangeAuthor(e.target.value)}
          />
        </FormControl>

        {!is_full_screen_category && (
          <FormControl
            fullWidth
            variant="standard"
            component="fieldset"
            sx={{ mb: "20px" }}
            disabled={!editAuthorized}
          >
            <InputLabel shrink>本文</InputLabel>
            <div style={{ height: "20px" }} />
            <TextareaAutosize
              defaultValue={topicItems.TOPIC_BODY?.replace(/\\n/g, "\n") || null}
              className="editBodyForm"
              onChange={(e) => onChangeBody(e.target.value)}
              placeholder="本文を入力してください"
            />
          </FormControl>
        )}

        <FormControl
          fullWidth
          variant="standard"
          disabled={!editAuthorized && !patrolAuthorized}
          sx={{ mb: "20px" }}
        >
          <InputLabel shrink>トピックの承認状態</InputLabel>
          <div style={{ height: "20px" }} />
          <RadioGroup
            row
            aria-label="position"
            name="position"
            value={topicItems.PATROLLED}
            onChange={(e) => onChangePatrolled(e.target.value)}
          >
            <FormControlLabel
              value="NOTYET"
              control={<Radio color="primary" />}
              label="未確認"
            />
            <FormControlLabel
              value="ACCEPTED"
              control={<Radio color="primary" />}
              label="承認"
            />
            <FormControlLabel
              value="REJECTED"
              control={<Radio color="primary" />}
              label="却下"
            />
          </RadioGroup>
        </FormControl>

        <FormControl
          fullWidth
          variant="standard"
          disabled={!editAuthorized}
          sx={{ mb: "20px" }}
        >
          <InputLabel shrink>添付ファイル</InputLabel>
          <div style={{ height: "20px" }} />
          <Stack direction="row" spacing={2} className="imagepicker_wrapper">
            <Button
              varient="elevated"
              startIcon={<ImageIcon />}
              onClick={onAddImageButtonClicked}
            >
              画像
            </Button>
            <Button
              varient="elevated"
              startIcon={<YouTubeIcon />}
              onClick={toggleYoutubeModal}
            >
              動画
            </Button>
            <Button
              varient="elevated"
              startIcon={<PictureAsPdfIcon />}
              onClick={togglePdfModal}
            >
              PDF
            </Button>
          </Stack>
        </FormControl>

        {editImage}

        <form style={{ display: "none" }}>
          <Input
            disabled={!editAuthorized}
            id="fileForm"
            type="file"
            multiple
            accept="image/*"
            onChange={(evt) => {
              onAddImage(evt.currentTarget.files)
              // evt.currentTarget.parentElement.reset();
            }}
          />
        </form>

        <form style={{ display: "none" }}>
          <Input
            disabled={!editAuthorized}
            id="fileFormPdf"
            type="file"
            accept="application/pdf"
            onChange={(evt) => {
              onAddPdf(evt.currentTarget.files)
              // evt.currentTarget.parentElement.reset();
            }}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          style={{ width: "150px" }}
          onClick={() => {
            onSubmit()
          }}
        >
          {submitText}
        </Button>
        <Button
          color="primary"
          style={{ width: "150px" }}
          onClick={() => {
            props.onReset()
            props.toggleModal()
          }}
        >
          キャンセル
        </Button>
      </DialogActions>

      <Dialog
        open={youtubeModalIsOpen}
        onCancel={() => {
          toggleYoutubeModal()
        }}
        aria-labelledby="form-dialog-title"
        maxWidth={"sm"}
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          YouTubeの動画を添付する
        </DialogTitle>
        <DialogContent>
          <DialogContentText>動画のURLを入力してください</DialogContentText>
          <div style={{ height: "20px" }} />
          <TextField
            fullWidth
            autoFocus
            variant="standard"
            label="URL"
            placeholder="https://youtu.be/..."
            value={youtubeUrl}
            onChange={(evt) => setYoutubeUrl(evt.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleYoutubeModal} color="primary">
            キャンセル
          </Button>
          <Button onClick={onDecideYouTubeURL} color="primary">
            決定
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={pdfModalIsOpen}
        onClose={() => {
          togglePdfModal()
        }}
      >
        <DialogTitle>PDFを添付する</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="pdfType"
              name="pdfType"
              onChange={(e) => setPdfType(e.target.value)}
            >
              <FormControlLabel
                value="pdf_normal"
                control={<Radio />}
                label="通常"
              />
              <FormControlLabel
                value="pdf_spread"
                control={<Radio />}
                label="見開き"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onAddPdfButtonClicked} color="primary">
            決定
          </Button>
          <Button onClick={togglePdfModal} color="primary">
            キャンセル
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={alertItems.alertModalIsOpen}
        onClose={closeAlertModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>{alertItems.alertBody}</DialogContent>
        <DialogActions>
          <Button onClick={closeAlertModal} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  )
}

export default TopicForm

TopicForm.defaultProps = {
  TOPIC_ID: 0,
  CATEGORY_ID: 0,
  TOPIC_TITLE: "",
  TOPIC_BODY: "",
  TOPIC_AUTHOR_NAME: "",
  TOPIC_AVAILABLE_FROM: moment(),
  TOPIC_AVAILABLE_TO: moment().add(1, "weeks"),
  MEDIAS: [],
  PATROLLED: "",
  onReset: function () {},
}
